const MainMenuData = [
	// {
	// 	title: 'Applications',
	// 	hidden: true,
	// 	img: window.ackShopifyFileUrl('V4_Overview_8b073348-4ffd-45fb-be88-38c79b554653.png'),
	// 	class: 'applications',
	// 	items: [
	// 		{
	// 			url: '/pages/application-workflow-crown',
	// 			img: window.ackShopifyFileUrl('V4-Workflow_Overview.png'),
	// 			title: 'Crown Workflow',
	// 			readonly: false,
	// 		},
	// 		{
	// 			url: '/pages/application-workflow-splint',
	// 			img: window.ackShopifyFileUrl('V4_Application_Workflow_Splint.png'),
	// 			title: 'Splint Workflow',
	// 			readonly: false,
	// 		},
	// 		{
	// 			url: '/pages/application-workflow-model',
	// 			img: window.ackShopifyFileUrl('V4_Application_Workflow_Model.png'),
	// 			title: 'Model Workflow',
	// 			readonly: false,
	// 		},
	// 		{
	// 			url: '/pages/application-workflow-all-on-x',
	// 			img: window.ackShopifyFileUrl('All_on_X_icon_2e6f797e-d75b-452b-9675-2f471db99270.png'),
	// 			title: 'All-on-X Workflow',
	// 			readonly: false,
	// 		},
	// 		/*
	//     {url: '#', img:window.ackShopifyFileUrl("V4_Crown.png"), title:'Crown, Bridge & Veneer', readonly: false},

	//     {url: '#', img:window.ackShopifyFileUrl("V4_Surgical_Guide.png"), title:'Surgical Guide', readonly: false},
	//     {url: '#', img:window.ackShopifyFileUrl("V4_Full_Arch_Implant.png"), title:'Full Arch Implant', readonly: false},
	//     {url: '#', img:window.ackShopifyFileUrl("V4_Denture.png"), title:'Denture', readonly: false},
	//     {url: '#', img:window.ackShopifyFileUrl("V4_Castable.png"), title:'Castables', readonly: false},
	//     {url: '#', img:window.ackShopifyFileUrl("V4_IBT.png"), title:'IBT', readonly: false},
	//     {url: '#', img:window.ackShopifyFileUrl("V4_Tray.png"), title:'Tray', readonly: false},
	//     */
	// 	],
	// },
	{
		title: 'Materials',
		img: window.ackShopifyFileUrl('resin_bottle.png'),
		class: 'resins',
		customLayout: 'materials',
		groups: [
			{
				title: 'Rodin Resins',
				columns: [
					[
						{
							title: 'RapidCeram',
							url: '/products/rodin-rapidceram',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_RapidCeram.png?v=1783562635',
						},
						{
							title: 'EnVision',
							url: '/products/rodin-envision',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_EnVision.png?v=1783562634',
						},
						{
							title: 'Titan',
							url: '/products/rodin-titan',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Titan.png?v=1783562634',
						},
						{
							title: 'Sculpture 2.0',
							url: '/products/rodin-sculpture-2-0',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Sculpture_2.0.png?v=1783562634',
						},
					],
					[
						{
							title: 'Denture Base 2.0',
							url: '/products/rodin-denture-base-2-0',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Denture_Base_2.0.png?v=1783562634',
						},
						{
							title: 'BioArch RPD',
							url: '/products/bioarch-rpd',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_BioArch_RPD.png?v=1783562635',
						},
						{
							title: 'Try-In',
							url: '/products/rodin-try-in',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Try-In.png?v=1783562634',
						},
						{
							title: 'TruModel',
							url: '/products/trumodel',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_TruModel.png?v=1783562634',
						},
						{
							title: 'Surgical Guide 2.0',
							url: '/products/rodin-surgical-guide-2-1',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Surgical_Guide_2.0.png?v=1783562635',
						},
					],
					[
						{
							title: 'Flexisplint',
							url: '/products/rodin-flexisplint-1',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Flexisplint.png?v=1783562634',
						},
						{
							title: 'Splint 2.0 (Rigid)',
							url: '/products/rodin-splint-2-1',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Splint_2.0_Rigid.png?v=1783562634',
						},
						{
							title: 'Ortho IBT',
							url: '/products/rodin-ortho-ibt-1',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Ortho_IBT.png?v=1783562635',
						},
						{
							title: 'Castable',
							url: '/products/rodin-castable-1',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Castable.png?v=1783562635',
						},
						{
							title: 'Bite Tray',
							url: '/products/rodin-bite-tray-1',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Bite_Tray.png?v=1783562635',
						},
					],
				],
			},
			{
				title: 'Post-Processing',
				items: [
					{
						title: 'Glaze N2-Free',
						url: '/products/rodin-n2-free-glaze',
						icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_N2-Free_Glaze.png?v=1783562634',
					},
					{
						title: 'Palette 2.0 with Glaze N2-Free',
						url: '/products/n2-free-palette-naturalizing-kit',
						icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_N2-Free_Palette.png?v=1783562634',
					},
					{
						title: 'Universal Resin Cleaner',
						url: '/products/resin-cleaner',
						icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Resin_Cleaner.png?v=1783562634',
					},
				],
			},
			{
				title: 'Restorative',
				items: [
					{
						title: 'Luting Cement',
						url: '/products/rodin-luting-cement',
						icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Luting_Cement.png?v=1783562634',
					},
					{
						title: 'Rodin Bond Dental Adhesive Kit',
						url: '/products/rodin-bond-dental-adhesive-bottle-kit',
						icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_icon_Bond_Dental_Adhesive_Kit.png?v=1783562634',
					},
				],
			},
		],
		items: [],
	},
	// groupsLayout= 0 (default) | 1 (vertical) | 2 (horizontal)
	// https://cdn.ackuretta.com/public/menu/Icons/64x64-transparent.png
	// V4_Products.png is resolved through window.ackShopifyFileUrl.
	{
		title: '3D Printing Products',
		img: window.ackShopifyFileUrl('V4_Products.png'),
		hasGroups: true,
		groupsLayout: 1,
		numberOfGroups: 5,
		groupNames: ['3D Printers', 'Curing Devices', 'Washers', 'Accessories'],
		class: 'products',
		items: [
			{
				url: '/products/sol-plus',
				img: window.ackShopifyFileUrl('V4_SOL_Plus.png'),
				title: 'SOL Plus',
				readonly: false,
				itemGroup: 1,
			},
			{
				url: '/products/sol-se-dental-3d-printer',
				img: window.ackShopifyFileUrl('SOL_SE_Front_1.png'),
				title: 'SOL SE',
				readonly: false,
				itemGroup: 1,
			},
			{
				url: '/products/dentiq-dental-3d-printer',
				img: window.ackShopifyFileUrl('V4_DENTIQ_484db7f2-ce35-42c0-a431-c17f7c94ae4e.png'),
				title: 'DENTIQ',
				readonly: false,
				itemGroup: 1,
			},
			{
				url: '/products/rodin-chroma-flash',
				img: window.ackShopifyFileUrl('Rodin_Chroma_Flash_icon_front.png'),
				title: 'Rodin Chroma Flash',
				readonly: false,
				itemGroup: 2,
			},
			{
				url: '/products/curie-plus',
				img: window.ackShopifyFileUrl(
					'Navigation_Bar_Products_CURIE_Plus_NFinity_2159d16e-9415-4167-b992-3b0531406979.png',
				),
				title: 'CURIE Plus & NFinity',
				readonly: false,
				itemGroup: 2,
			},
			{
				url: '/products/curie-uv-oven-for-dental-3d-printing',
				img: window.ackShopifyFileUrl('V4_CURIE_13abe7ab-4b49-44e9-8de1-d972b000bbb6.png'),
				title: 'CURIE',
				readonly: false,
				itemGroup: 2,
			},
			{
				url: '/products/uv-box-for-dental-3d-printing',
				img: window.ackShopifyFileUrl('V4_CURIE_Plus_c9b05e5e-4701-45ae-94f5-094b8964bc32.png'),
				title: 'UV Box',
				readonly: false,
				itemGroup: 2,
			},
			{
				url: '/products/cleani-tank-plus',
				img: window.ackShopifyFileUrl('V4_Tank_Plus.png'),
				title: 'CLEANI with Tank Plus',
				readonly: false,
				itemGroup: 3,
			},
			{
				url: '/products/cleani-washer-for-dental-3d-printing',
				img: window.ackShopifyFileUrl('V4_Dual_Tanks.png'),
				title: 'CLEANI with Dual Tanks',
				readonly: false,
				itemGroup: 3,
			},

			{
				url: '/pages/sol-build-platforms',
				img: window.ackShopifyFileUrl('V4_BPs.png'),
				title: 'SOL SE Build Platforms',
				hidden: true,
				readonly: false,
				itemGroup: 4,
			},
			{
				url: '/pages/store?collection=shop-consumables#shop-product-anchor',
				img: window.ackShopifyFileUrl('V4_Vat.png'),
				title: 'Other Accessories',
				readonly: false,
				itemGroup: 4,
				onlyIfStoreAvailable: true,
			},
		],
	},

	{
		title: 'Software',
		img: window.ackShopifyFileUrl('V4_Software.png'),
		class: 'software',
		items: [
			{
				url: '/pages/alpha-ai-slicing-software-for-dental-3d-printing',
				img: window.ackShopifyFileUrl('V4-ALPHA_AI_63896cc6-4041-4bc4-9698-72520f1c61ef.png'),
				title: 'Slicing Software',
				readonly: false,
			},
		],
	},

	{
		title: 'Services',
		img: window.ackShopifyFileUrl('V4_Services.png'),
		class: 'services',
		items: [
			{
				url: '/pages/ackuretta-concierge',
				img: window.ackShopifyFileUrl('V4_Ackuretta_Concierge.png'),
				title: 'Ackuretta Concierge',
				readonly: false,
			},
			{
				url: '',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ExtendedCoveragePicture.png?v=1780987303',
				title: 'Extended Coverage',
				readonly: false,
			},
			{
				url: '/pages/personalized-training',
				img: window.ackShopifyFileUrl('V4_Personalized_Training.png'),
				title: 'Personalized Training',
				readonly: false,
				hidden: true,
				hideItemInCountries: ['US', 'CA'],
			},
			// keep lease program link in case any retrieval request
			// {
			// 	url: 'https://go.ackuretta.com/sol-lease-program/downloads',
			// 	img: window.ackShopifyFileUrl("V4_SOL_Lease_Program.png"),
			// 	title: 'Lease Program',
			// 	readonly: false,
			// 	target: '_blank',
			// 	hideItemInCountries: ['US', 'CA', 'CN', 'RU'],
			// },
			{
				url: 'https://go.ackuretta.com/verieko-conversion',
				img: window.ackShopifyFileUrl('V4_VeriEKO.png'),
				title: 'VeriEko & LCD1 Conversion',
				readonly: false,
				target: '_blank',
			},
		],
	},

	{
		title: 'Resources',
		img: window.ackShopifyFileUrl('V4_Resources.png'),
		class: 'resources',
		items: [
			{
				url: '/blogs/news',
				img: window.ackShopifyFileUrl('V4_Articles.png'),
				title: 'Articles',
				readonly: false,
			},
			{
				url: '/pages/video-gallery',
				img: window.ackShopifyFileUrl('V4_Video_Gallery_f646518e-1e15-493d-92ff-e386a82ce15c.png'),
				title: 'Video Gallery',
				readonly: false,
			},
			{
				url: '/pages/events',
				img: window.ackShopifyFileUrl('V4_Events_c61b5e4d-2682-44f6-9f99-9335a502276b.png'),
				title: 'Events',
				readonly: false,
			},
			{
				url: '/pages/newsletter',
				img: window.ackShopifyFileUrl(
					'V4_Subscribe_to_Newsletter_baba062c-05bd-46f3-b486-0c1389993f24.png',
				),
				title: 'Subscribe to Newsletter',
				readonly: false,
				hidden: true,
			},
			{
				url: '/pages/downloads',
				img: window.ackShopifyFileUrl('V4_Downloadables.png'),
				title: 'Downloadables',
				readonly: false,
			},
		],
	},
	{
		title: 'Support',
		img: window.ackShopifyFileUrl('V4_Tech_Support_Ticket.png'),
		class: 'support',
		items: [
			{
				url: 'https://dashboard.ackuretta.com/',
				img: window.ackShopifyFileUrl('V4_User_dashboard_0daf0ea9-0eab-418f-9979-49c1d53d9bfa.png'),
				title: 'User Dashboard',
				readonly: false,
				target: '_blank',
			},
			{
				// url: '/pages/tech-support-ticket',
				url: 'https://dashboard.ackuretta.com/dashboard/support',
				img: window.ackShopifyFileUrl('V4_Support.png'),
				title: 'Tech Support Ticket',
				readonly: false,
			},
			{
				url: 'https://info.ackuretta.com/',
				img: window.ackShopifyFileUrl('V4_Help_Center.png'),
				title: 'Help Center',
				readonly: false,
				target: '_blank',
			},
			{
				url: '/pages/warranty-policy-and-return-refund-conditions',
				img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Warrwnty.png?v=1780984278',
				title: 'Warranty Policy',
				readonly: false,
			},
		],
	},
	{
		title: 'Partners',
		img: window.ackShopifyFileUrl(
			'V4_Partners___Distributors_0673fe7f-34b8-49d6-b76a-a4c1ffa13817.png',
		),
		class: 'partners',
		items: [
			{
				url: '/account/login',
				img: window.ackShopifyFileUrl(
					'V4_Distributor_dashboard_32c4d497-046a-441e-9808-b2772a0cf154.png',
				),
				title: 'Distributor Dashboard',
				readonly: false,
			},
			{
				url: '/pages/partner-and-distributors',
				img: window.ackShopifyFileUrl(
					'V4_Partners___Distributors_4fc0533d-f9c7-4ed4-8a2c-0788fd65bc81.png',
				),
				title: 'Partners and Distributors',
				readonly: false,
			},
			{
				url: '/pages/become-our-distributor',
				img: window.ackShopifyFileUrl('V4_Become_Our_Distributors.png'),
				title: 'Become Our Distributor',
				readonly: false,
			},
			// {
			// 	url: '/pages/partner-with-us',
			// 	img: window.ackShopifyFileUrl('V4_Partner_with_Us.png'),
			// 	title: 'Partner With Us',
			// 	readonly: false,
			// },
		],
	},

	// { title: 'Contact', img: window.ackShopifyFileUrl("V4_Contact.png"), items:
	// [
	//   {url: '#', img:window.ackShopifyFileUrl("V4-Contact.png"), title:'Contact a Dental Specialist', readonly: false},
	// ]
	// }
];
